import { useEffect } from 'react';
import { PipelineAnalyticsDashboard } from '@/components/pipeline/PipelineAnalyticsDashboard';

export default function AnalyticsPage() {
  useEffect(() => {
    document.title = 'Management Dashboard - DomElec Solar';
  }, []);

  return (
    <div data-testid="page-analytics" className="container mx-auto">
      <PipelineAnalyticsDashboard />
    </div>
  );
}